import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import TituloSessao from '../componentes/TituloSessao';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';

import AlcanceTotalEMensal from '../componentes/graficos/AlcanceTotalEMensal';
import LineChartDetalhamentoIndicadorOuEstabelecimento from '../componentes/graficos/LineChartDetalhamentoIndicadorOuEstabelecimento';
import HeatMapAlcanceUnidades from '../componentes/graficos/HeatMapAlcanceUnidades';
import DataMes from '../componentes/DataMes';
import TabelaDetalhamentoIndicadorEstabelecimento from '../componentes/graficos/TabelaDetalhamentoIndicadorEstabelecimento';

function Graficos() {

    console.log("##INICIANDO GRAFICOS##");

    const [estabelecimento, setEstabelecimento] = useState(null)
    const [dataInicio, setDataInicio] = useState(null)
    const [dataFim, setDataFim] = useState(null)
    const [renderizaGraficos, setRenderizaGraficos] = useState(false)

    useEffect(() => {
        // Chama os graficos apenas se tiver datas definidas
        if (dataInicio && dataFim) {
            // Se as datas estiverem definidas, preciso verificar se eh valida
            if (dataInicio > dataFim) {
                setRenderizaGraficos(false)
                toast.error('A data inicial não pode ser maior que a data final');
            } else {
                setRenderizaGraficos(true)
            }
        }
    }, [dataInicio, dataFim]);

    return (
        <div className='container-fluid d-flex flex-column gap-3 p-3'>
            {/* <TituloSessao titulo='Dashboard' barraDecorativa={false} />  sticky-md-top */}
            <div className='m-0 d-flex flex-column flex-md-row justify-content-center gap-3 p-2 div-com-borda align-items-center' style={{ 'marginTop': '3em' }}>
                <div className='col-12 col-md-2 d-flex gap-1 align-items-center'>
                    <label className='text-nowrap' htmlFor='graf-data-inicial'>Data Inicio</label>
                    <DataMes id='graf-data-inicial' setData={setDataInicio} getUltimoDia={false} />
                </div>
                <div className='col-12 col-md-2 d-flex gap-1 align-items-center'>
                    <label className='text-nowrap' htmlFor='graf-data-final'>Data Fim</label>
                    <DataMes id='graf-data-final' setData={setDataFim} getUltimoDia={true} />
                </div>
                <div className='col-12 col-md-7'>
                    <BarraBuscaComTodasUnidades
                        setEstabelecimento={setEstabelecimento}
                        somenteAtivos={false}
                        enviaRelatorioAcompanhamento={false}
                    />
                </div>
            </div>
            {renderizaGraficos ?
                (
                    <>
                        <TituloSessao titulo='Percentual de alcance mensal dos indicadores de desempenho' barraDecorativa={true} tituloAlignStart={true} />
                        <div style={{ 'height': '25em' }}>
                            <AlcanceTotalEMensal
                                dataInicio={dataInicio}
                                dataFim={dataFim}
                            />
                        </div>
                        {estabelecimento ?
                            <>
                                <TituloSessao titulo='Detalhamento por unidade' barraDecorativa={true} tituloAlignStart={true} />
                                <LineChartDetalhamentoIndicadorOuEstabelecimento
                                    estabelecimento={estabelecimento}
                                    dataInicio={dataInicio}
                                    dataFim={dataFim}
                                />
                                <TituloSessao titulo='Percentual de alcance por unidade' barraDecorativa={true} tituloAlignStart={true} />
                                <div className=''>
                                    <TabelaDetalhamentoIndicadorEstabelecimento
                                        estabelecimento={estabelecimento}
                                        dataInicio={dataInicio}
                                        dataFim={dataFim}
                                    />
                                </div>
                            </>
                            :
                            <>
                                <TituloSessao titulo='Detalhamento por indicador' barraDecorativa={true} tituloAlignStart={true} />
                                <LineChartDetalhamentoIndicadorOuEstabelecimento
                                    dataInicio={dataInicio}
                                    dataFim={dataFim}
                                />
                                <TituloSessao titulo='Percentual de unidades que alcançaram determinado indicador' barraDecorativa={true} tituloAlignStart={true} />
                                <div style={{ 'height': '25em' }}>
                                    <HeatMapAlcanceUnidades
                                        dataInicio={dataInicio}
                                        dataFim={dataFim}
                                    />
                                </div>
                            </>
                        }
                    </>
                )
                :
                (
                    <div className='text-center'>
                        <p>Selecione ao menos uma <strong>data início</strong> e uma <strong>data fim</strong> para buscar as informações no banco de dados</p>
                    </div>
                )
            }
        </div>
    );
}

export default Graficos
